import { render } from "./Home.vue?vue&type=template&id=3b16b8be&scoped=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=3b16b8be&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3b16b8be"

export default script